import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OperatorApplicationDialogTopMenuButton',
  props: {
    icon: {},
    className: {},
    purple: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
    class: _normalizeClass(["button", {[__props.className]: true, purple: __props.purple}]),
    icon: __props.icon,
    light: ""
  }, null, 8, ["class", "icon"])), [
    [_directive_on_native, () => _unref(emits)('click'), "click"]
  ])
}
}

})